import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type DeleteAllCorporationAttackListSenderSettingsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteAllCorporationAttackListSenderSettingsMutation = { __typename?: 'Mutation', deleteAllCorporationAttackListSenderSettings: { __typename?: 'DeleteAllCorporationSettingsPayload', isSucceeded: boolean } };

export type CreateCorporationAttackListSenderSettingsMutationVariables = Types.Exact<{
  input: Types.CreateAttackListSenderSettingsInput;
}>;


export type CreateCorporationAttackListSenderSettingsMutation = { __typename?: 'Mutation', createCorporationAttackListSenderSettings: { __typename?: 'CreateAttackListSenderSettingsPayload', isSucceeded: boolean } };

export type RollbackAttackListSenderSettingsMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RollbackAttackListSenderSettingsMutation = { __typename?: 'Mutation', rollbackCorporationAttackListSenderSettings: any };

export type FetchRevisionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchRevisionsQuery = { __typename?: 'Query', corporationAttackListSenderSettingRevisions: Array<{ __typename?: 'AttackListSenderSettingRevision', id: string, createdAt: TimeString }> };

export type AttackListSenderSettingCsvPageViewerQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AttackListSenderSettingCsvPageViewerQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', attackListSender: { __typename?: 'AttackListSenderFeature', available: boolean } } };


export const DeleteAllCorporationAttackListSenderSettingsDocument = gql`
    mutation deleteAllCorporationAttackListSenderSettings {
  deleteAllCorporationAttackListSenderSettings {
    isSucceeded
  }
}
    `;

/**
 * __useDeleteAllCorporationAttackListSenderSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteAllCorporationAttackListSenderSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllCorporationAttackListSenderSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAllCorporationAttackListSenderSettingsMutation();
 */
export function useDeleteAllCorporationAttackListSenderSettingsMutation(options: VueApolloComposable.UseMutationOptions<DeleteAllCorporationAttackListSenderSettingsMutation, DeleteAllCorporationAttackListSenderSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAllCorporationAttackListSenderSettingsMutation, DeleteAllCorporationAttackListSenderSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAllCorporationAttackListSenderSettingsMutation, DeleteAllCorporationAttackListSenderSettingsMutationVariables>(DeleteAllCorporationAttackListSenderSettingsDocument, options);
}
export type DeleteAllCorporationAttackListSenderSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAllCorporationAttackListSenderSettingsMutation, DeleteAllCorporationAttackListSenderSettingsMutationVariables>;
export const CreateCorporationAttackListSenderSettingsDocument = gql`
    mutation createCorporationAttackListSenderSettings($input: CreateAttackListSenderSettingsInput!) {
  createCorporationAttackListSenderSettings(input: $input) {
    isSucceeded
  }
}
    `;

/**
 * __useCreateCorporationAttackListSenderSettingsMutation__
 *
 * To run a mutation, you first call `useCreateCorporationAttackListSenderSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCorporationAttackListSenderSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCorporationAttackListSenderSettingsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCorporationAttackListSenderSettingsMutation(options: VueApolloComposable.UseMutationOptions<CreateCorporationAttackListSenderSettingsMutation, CreateCorporationAttackListSenderSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCorporationAttackListSenderSettingsMutation, CreateCorporationAttackListSenderSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCorporationAttackListSenderSettingsMutation, CreateCorporationAttackListSenderSettingsMutationVariables>(CreateCorporationAttackListSenderSettingsDocument, options);
}
export type CreateCorporationAttackListSenderSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCorporationAttackListSenderSettingsMutation, CreateCorporationAttackListSenderSettingsMutationVariables>;
export const RollbackAttackListSenderSettingsDocument = gql`
    mutation rollbackAttackListSenderSettings($id: ID!) {
  rollbackCorporationAttackListSenderSettings(targetRevisionId: $id)
}
    `;

/**
 * __useRollbackAttackListSenderSettingsMutation__
 *
 * To run a mutation, you first call `useRollbackAttackListSenderSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRollbackAttackListSenderSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRollbackAttackListSenderSettingsMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRollbackAttackListSenderSettingsMutation(options: VueApolloComposable.UseMutationOptions<RollbackAttackListSenderSettingsMutation, RollbackAttackListSenderSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RollbackAttackListSenderSettingsMutation, RollbackAttackListSenderSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RollbackAttackListSenderSettingsMutation, RollbackAttackListSenderSettingsMutationVariables>(RollbackAttackListSenderSettingsDocument, options);
}
export type RollbackAttackListSenderSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RollbackAttackListSenderSettingsMutation, RollbackAttackListSenderSettingsMutationVariables>;
export const FetchRevisionsDocument = gql`
    query fetchRevisions {
  corporationAttackListSenderSettingRevisions {
    id
    createdAt
  }
}
    `;

/**
 * __useFetchRevisionsQuery__
 *
 * To run a query within a Vue component, call `useFetchRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRevisionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchRevisionsQuery();
 */
export function useFetchRevisionsQuery(options: VueApolloComposable.UseQueryOptions<FetchRevisionsQuery, FetchRevisionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchRevisionsQuery, FetchRevisionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchRevisionsQuery, FetchRevisionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchRevisionsQuery, FetchRevisionsQueryVariables>(FetchRevisionsDocument, {}, options);
}
export function useFetchRevisionsLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchRevisionsQuery, FetchRevisionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchRevisionsQuery, FetchRevisionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchRevisionsQuery, FetchRevisionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchRevisionsQuery, FetchRevisionsQueryVariables>(FetchRevisionsDocument, {}, options);
}
export type FetchRevisionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchRevisionsQuery, FetchRevisionsQueryVariables>;
export const AttackListSenderSettingCsvPageViewerDocument = gql`
    query AttackListSenderSettingCsvPageViewer {
  viewer {
    attackListSender {
      available
    }
  }
}
    `;

/**
 * __useAttackListSenderSettingCsvPageViewerQuery__
 *
 * To run a query within a Vue component, call `useAttackListSenderSettingCsvPageViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttackListSenderSettingCsvPageViewerQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAttackListSenderSettingCsvPageViewerQuery();
 */
export function useAttackListSenderSettingCsvPageViewerQuery(options: VueApolloComposable.UseQueryOptions<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>(AttackListSenderSettingCsvPageViewerDocument, {}, options);
}
export function useAttackListSenderSettingCsvPageViewerLazyQuery(options: VueApolloComposable.UseQueryOptions<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>(AttackListSenderSettingCsvPageViewerDocument, {}, options);
}
export type AttackListSenderSettingCsvPageViewerQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>;